import { jsx as _jsx } from "react/jsx-runtime";
import { useLoadingScreenContext } from "../../loading-screen-context";
import { StyledLoadingOverlayComponent } from "./loading-overlay-component.scss";
import BookAMeetingLoadingScreen from "./loading-screen-types/book-a-meeting-loading-screen/book-a-meeting-loading-screen";
import { LOADER_TYPES } from "contexts/types/loader-types";
import SettingUpCallLoadingScreen from "./loading-screen-types/setting-up-call-loading-screen/setting-up-call-loading-screen";
const altLoadingScreenContentText = "Loading, please wait...";
const LOADING_SCREEN_TYPES_TO_LOADER = {
    [LOADER_TYPES.BOOK_A_MEETING]: /*#__PURE__*/ _jsx(BookAMeetingLoadingScreen, {}),
    [LOADER_TYPES.SETTING_UP_CALL]: /*#__PURE__*/ _jsx(SettingUpCallLoadingScreen, {}),
    [LOADER_TYPES.DEFAULT]: /*#__PURE__*/ _jsx("p", {
        children: altLoadingScreenContentText
    })
};
const LoadingOverlayComponent = ()=>{
    const { isLoadingScreen, loadingScreenType, behavior } = useLoadingScreenContext();
    if (!isLoadingScreen) return null;
    return /*#__PURE__*/ _jsx(StyledLoadingOverlayComponent, {
        isTransparent: behavior.isTransparent,
        children: LOADING_SCREEN_TYPES_TO_LOADER[loadingScreenType] || LOADING_SCREEN_TYPES_TO_LOADER[LOADER_TYPES.DEFAULT]
    });
};
export default LoadingOverlayComponent;
